import React from "react";
import { Combobox, Option } from "@fluentui/react-components";
import { Avatar, makeStyles, shorthands } from "@fluentui/react-components";

const useStyles = makeStyles({
  optionContent: {
    display: "flex",
    alignItems: "center",
    ...shorthands.gap("8px"),
  },
});

export function GenericComboBox({
  items = [],
  value,
  valueKey,
  displayKey,
  iconKey,
  includeEmptyOption = false,
  placeholder = "Select an option",
  itemTemplate,
  onOptionSelect,
  onOptionSelectFull,
  ...rest
}) {
  const styles = useStyles();

  const getLabel = (item) => {
    if (!item) return "";
    if (typeof displayKey === "function") return String(displayKey(item));
    return String(item?.[displayKey] ?? "");
  };

  const selectedItem = items.find((item) => item[valueKey] === value);
  const selectedLabel = getLabel(selectedItem);

  const handleSelect = (_, data) => {
    const selectedValue = data?.optionValue;
    const matched = items.find((item) => getLabel(item) === selectedValue);
    onOptionSelect?.(matched?.[valueKey] ?? null);
    onOptionSelectFull?.(matched);
  };

  return (
    <Combobox
      value={selectedLabel}
      onOptionSelect={handleSelect}
      includeEmptyOption={includeEmptyOption}
      placeholder={placeholder}
      {...rest}
    >
      {includeEmptyOption && <Option value="">--</Option>}
      {items.map((item) => (
        <Option key={item[valueKey]} value={getLabel(item)}>
          {itemTemplate ? (
            itemTemplate(item)
          ) : (
            <div className={styles.optionContent}>
              {iconKey && item[iconKey] && <Avatar image={{ src: item[iconKey] }} size={20} name="" />}
              <span>{getLabel(item)}</span>
            </div>
          )}
        </Option>
      ))}
    </Combobox>
  );
}
